<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewDieselInfo ViewPromo__section">
      <div class="ViewDieselInfo__row">
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__content">
            <h2 class="ViewDieselInfo__title">{{ name }}</h2>
            <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
            <div class="ViewDieselInfo__text app-typography">
              <h4>О компании:</h4>
              <p>
                Как цифровой топливный интегратор решает проблемы
                топливообеспечения предприятий, путем внедрения комплексных
                сервисных услуг. Компания бесплатно устанавливает контейнерные
                автозаправочные станции, а технику, работающую на удаленных
                объектах, заправляет бустерами.
              </p>
              <p>
                Компания осуществляет непрерывные поставки со всех ведущих
                заводов России, а собственный ёмкостной парк хранения топлива
                позволяет бесперебойно поставлять его клиентам сервиса.
                «ВезиБензин» контролирует качество продукта на каждом этапе от
                завода-изготовителя до конечного потребителя.
              </p>
              <p>
                Мобильная заправка сотрудничает с заводами «Газпром нефть»,
                «Роснефть» и «Лукойл».
              </p>
              <p>
                География работы компании — Томская область и Пермский край.
              </p>
            </div>
          </div>
        </div>
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__advantages-wrapper">
            <ul class="ViewPromo__advantages">
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="iphone"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Данные поставщика</h4>
                  <p>
                    Телефон компании:<br />
                    <strong
                      ><a
                        href="tel:+73822205555"
                        class="ViewPromo__advantage-contact-link"
                        >+7(3822)20-55-55</a
                      ></strong
                    >
                  </p>
                  <p>
                    Адрес электронной почты:<br />
                    <strong
                      ><a
                        href="mailto:kazakva@vezibenzin.com"
                        class="ViewPromo__advantage-contact-link"
                        >kazakva@vezibenzin.com</a
                      ></strong
                    >
                  </p>
                  <!-- <a
                      class="ViewPromo__advantage-link"
                      href="/static/uploads/docs/Cкачать_реквизиты_пром-ресурс.doc"
                      download="Реквизиты ПромРесурс.doc"
                      >Cкачать реквизиты ПромРесурс</a
                    > -->
                </div>
              </li>
              <!-- <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                    <p>
                      ДТ Рузаевка; н/б Аэрофьюлз (Аэропорт г. Нижний
                      Новгород);<br />
                      Дельта Торг
                    </p>
                  </div>
                </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title:
      'Топливо оптом онлайн от поставщика ВезиБензин на платформе OPEN OIL MARKET ',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1208,
    productId: 2069,
    name: 'ООО «ВезиБензин»',
    inn: '7017480245',
  }),
};
</script>
